import React from 'react';
import { Link } from 'react-router-dom';
import { ChevronRight, Home } from 'lucide-react';

const Breadcrumbs = ({ items = [] }) => (
  <nav aria-label="Breadcrumb" className="text-xs text-gray-500 flex items-center flex-wrap gap-1" data-testid="breadcrumbs">
    <Link to="/" className="inline-flex items-center gap-1 hover:text-red-700"><Home className="h-3 w-3" /> Home</Link>
    {items.map((it, i) => (
      <React.Fragment key={i}>
        <ChevronRight className="h-3 w-3 text-gray-300" />
        {i === items.length - 1 ? (
          <span className="text-black font-medium" aria-current="page">{it.name}</span>
        ) : (
          <Link to={it.path} className="hover:text-red-700">{it.name}</Link>
        )}
      </React.Fragment>
    ))}
  </nav>
);

export default Breadcrumbs;
